"use strict";

exports.__esModule = true;
exports.isValidAlignment = isValidAlignment;
exports.Alignment = void 0;

require("core-js/modules/es6.object.freeze");

/**
 * Return whether or not a string is a valid Alignment
 * @param {string} type String to validate
 * @returns {boolean} true if valid, false if invalid
 */
function isValidAlignment(type) {
  return Alignment.hasOwnProperty(type);
}
/**
 * Enum for alignment options
 * @enum {string}
 */


var Alignment = {
  CENTER: 'CENTER',
  RIGHT: 'RIGHT'
};
exports.Alignment = Alignment;
Object.freeze(Alignment);